/**
 * Translate backend / free-text labels when a matching `enums.*` key exists; otherwise return original.
 */
export function translateEnum(t, raw) {
  if (raw == null || raw === '') return '';
  const str = String(raw).trim();
  const key = str
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/gi, '');
  if (!key) return str;
  const fullKey = `enums.${key}`;
  const out = t(fullKey);
  return out === fullKey ? str : out;
}
